import { Input, Typography } from "antd";
import React, { useMemo, useState } from "react";
import { AllBusinessesColumns } from "./columns";
import { API_URL, fetcher } from "../../../utils/fetcher";
import useSWR from "swr";
import { AllBusinessRoot } from "../../../types/AllBusinessTypes";
import { AppTable } from "../../../components/common";

export default function AllBusinesses() {
  const { Text } = Typography;
  const [searchText, setSearchText] = useState("");

  const { data: businessData, isLoading: businessLoading } =
    useSWR<AllBusinessRoot>(`${API_URL}/admin/allCompanies`, fetcher, {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      revalidateOnMount: true,
    });

  const filteredData = useMemo(() => {
    if (!searchText) return businessData?.data ?? [];

    return (businessData?.data ?? []).filter((item) =>
      item?.name?.toLowerCase().includes(searchText.toLowerCase())
    );
  }, [businessData?.data, searchText]);

  return (
    <div>
      <div className="allBusinesses">
        <div className="filterMenu">
          <Text className="title24">Businesses</Text>
          <Input.Search
            className="searchField"
            placeholder="Search here..."
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
        <AppTable
          rowKey={(record) => record._id}
          loading={businessLoading}
          columns={AllBusinessesColumns()}
          dataSource={filteredData}
        />
      </div>
    </div>
  );
}
